<template>
  <pop-up-layout 
    :title="$t('promociones.addDocumento')"
    :aceptar="$t('general.misc.add')"
    :disabled="addDocumentoDisabled"
    @volver="cerrarPopUp()"
    @aceptar="addDocumento()"
  >
    <v-form ref="form" v-model="valid" @submit.prevent="addDocumento">
      <v-layout column justify-center align-center my-4>
        <v-text-field
          v-model="descripcionDocumento"
          :rules="[rules.required, rules.max(100), ruleDescripcion]"
          :label="$t('general.misc.descripcion')"
          style="width: 300px"
          class="pb-1"
        />
        <FileUploader
          :subPopUp="true"
          style="height:168px; width: 200px"
          :maxNum="1"
          v-model="documento"
          :deletable="true"
        />
      </v-layout>
    </v-form>
  </pop-up-layout> 
</template>

<script>
import { mapActions } from 'vuex'
import FileUploader from '@/components/generic/fileUploader/FileUploader'
import rulesMixin from '@/mixins/rules.js'

export default {
  mixins: [rulesMixin],
  components: { FileUploader },
  props: {
    documentosSubidos: {
      type: Array
    }
  },
  data () {
    return {
      valid: true,
      documento: [],
      descripcionDocumento: ''
    }
  },
  computed: {
    addDocumentoDisabled () {
      return this.documento.length <= 0 || this.descripcionDocumento === ''
    },
    ruleDescripcion () {
      return !this.documentosSubidos.some(x => x.descripcionDocumento === this.descripcionDocumento) || 'La descripción del documento no debe coincidir con los ya subidos'
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add'
    }),
    addDocumento() {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
        return
      }
      this.documento[0].descripcionDocumento = this.descripcionDocumento
      this.$emit('add', this.documento[0])
    },
    cerrarPopUp () {
      this.$emit('cambiado', false)
      this.$parent.hide()
    }
  },
  watch: {
    documento: {
      deep: true,
      handler () {
        this.$emit('cambiado', true)
      }
    },
    descripcionDocumento: {
      deep: true,
      handler () {
        this.$emit('cambiado', true)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/reservas/documentacion/PopUpSubirDocumentacion.vue